<template>
  <div class="border">
    <div style="padding:1rem">
      <PageHeader title="คำถามที่ยังไม่ตอบทั้งหมด"></PageHeader>
      <b-row>
        <b-col cols="12">
          <discuss
            :apiRoute="`/v1/analytics/courses/getCourseOverviewDiscuss`"
            :perPage="10"
            :tab="true"
          ></discuss>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import discuss from "./panel/CourseDiscussPanel";
import PageHeader from "@/components/layouts/PageHeader.vue";
export default {
  data() {
    return {};
  },
  components: {
    PageHeader,
    discuss
  }
};
</script>
<style scoped></style>
